import { combineReducers } from 'redux';

import user from '../../services/Login/reducers';
import snackbarReducer from '../../components/flashMessages/snackbar';
import loaderReducer from '../../components/loader/loader';
import setUserReducer from '../../components/header/setUser';
import setDropshipFlagReducer from '../../components/header/setDropshipFlag';
import headerProductSearchReducer from '../../components/header/headerSearch';
import cartDetailsReducer from '../../pages/place-order/cartDetailsToStore';
import currentReturnItemReducer from '../../pages/return-center/currentReturnItemReducer';


const allReducers = combineReducers({
  authentication: user,
  snackbar: snackbarReducer,
  loader: loaderReducer,
  setUser: setUserReducer,
  headerProductSearch: headerProductSearchReducer,
  dropShipStatus: setDropshipFlagReducer,
  cartDetails: cartDetailsReducer,
  currentReturnItem: currentReturnItemReducer,
});

export default allReducers;
